import type { HTMLAttributes } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { getStatusInitials } from '@/utils/get-status-initials'

const sharedStyles = {
  warning: 'bg-alert-warning',
  success: 'bg-alert-success',
  danger: 'bg-alert-danger',
  monochromatic: 'bg-monochromatic-400',
}

const badgeVariants = tv({
  base: 'size-6 content-center text-white rounded-full text-center text-xs font-bold',
  variants: {
    variant: {
      '1': sharedStyles.warning,
      '2': sharedStyles.warning,
      '3': sharedStyles.success,
    },
  },
  defaultVariants: {
    variant: '1',
  },
})

export interface StatusBadgeProps
  extends Omit<VariantProps<typeof badgeVariants>, 'variant'>,
    HTMLAttributes<HTMLDivElement> {
  variant?: '1' | '2' | '3' | number
  description: string
}

export function SponsorshipReceiptStatusBadge({
  variant,
  className,
  description,
  ...props
}: StatusBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <div
            className={badgeVariants({
              variant: String(variant) as '1' | '2' | '3',

              className,
            })}
            {...props}
          >
            <span>{getStatusInitials(description)}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>{description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
